export default "__VITE_ASSET__96c95590__"